// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.NHWThMEJ {
  max-width: 800px;
  margin: 0 auto;
}

.QgMPWGl9 {
  font-size: 28px;
  font-weight: 700;
  color: #e0e0e0;
  margin-bottom: 4px;
}

.mWeTVp7r {
  font-size: 14px;
  color: #888;
  margin-bottom: 20px;
}

.dixhJvmk,
.OlDmAhrS {
  text-align: center;
  color: #888;
  padding: 40px 0;
  font-size: 16px;
}

.yz8jWziG {
  width: 100%;
  border-collapse: collapse;
  background: #16213e;
  border-radius: 8px;
  overflow: hidden;
}

.yz8jWziG thead {
  background: #1a1a2e;
}

.yz8jWziG th {
  padding: 12px 16px;
  text-align: left;
  font-size: 12px;
  font-weight: 600;
  color: #888;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  border-bottom: 1px solid #2a2a4a;
}

.XCgHhlvQ { width: 50px; text-align: center; }
.zIeTBFbV { }
.sWM9jDIM { width: 80px; text-align: center; }
.TnhquffF { width: 80px; text-align: right; }
._ahCWWe0 { width: 80px; text-align: center; }
.mXzJqIZT { width: 100px; text-align: center; }

.bHabcAeO td {
  padding: 10px 16px;
  font-size: 14px;
  color: #e0e0e0;
  border-bottom: 1px solid #2a2a4a;
}

.Gq54GtL3 td {
  padding: 10px 16px;
  font-size: 14px;
  color: #e0e0e0;
  border-bottom: 1px solid #2a2a4a;
  background: rgba(78, 204, 163, 0.1);
}

.vjsPrPOK {
  text-align: center;
  font-weight: 600;
  color: #888;
}

.oRJj4Kaa,
.z7GdM1eH,
.gB8fO3vS {
  font-size: 18px;
}

.esPMC9S4 {
  font-weight: 500;
}

.EqkwBd4k {
  text-align: center;
  color: #4ecca3;
  font-weight: 600;
}

.T7V_RsOo {
  text-align: right;
  color: #b0b0b0;
  font-variant-numeric: tabular-nums;
}

.gi9WFb7h {
  text-align: center;
  color: #b0b0b0;
}

.KTs0y2Ln {
  text-align: center;
  color: #b0b0b0;
}

.yow1uwVD {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 16px;
  margin-top: 16px;
  padding: 12px 0;
}

.xYRZ4y71 {
  background: rgba(78, 204, 163, 0.1);
  border: 1px solid rgba(78, 204, 163, 0.3);
  color: #4ecca3;
  padding: 6px 14px;
  border-radius: 6px;
  cursor: pointer;
  font-size: 13px;
  transition: background 0.2s;
}

.xYRZ4y71:hover:not(:disabled) {
  background: rgba(78, 204, 163, 0.2);
}

.xYRZ4y71:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

._5sFiApd {
  color: #888;
  font-size: 13px;
}

@media (max-width: 800px) {
  .yz8jWziG th,
  .bHabcAeO td,
  .Gq54GtL3 td {
    padding: 8px 10px;
    font-size: 12px;
  }

  .mXzJqIZT,
  .KTs0y2Ln {
    display: none;
  }

  .TnhquffF,
  .T7V_RsOo {
    width: 60px;
  }
}

/* Responsive: 480px phone breakpoint */
@media (max-width: 480px) {
  .QgMPWGl9 {
    font-size: 20px;
  }

  .yz8jWziG th,
  .bHabcAeO td,
  .Gq54GtL3 td {
    padding: 6px 6px;
    font-size: 11px;
  }

  ._ahCWWe0,
  .gi9WFb7h {
    display: none;
  }

  .sWM9jDIM,
  .EqkwBd4k {
    width: 50px;
  }

  .TnhquffF,
  .T7V_RsOo {
    width: 50px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/Leaderboard.module.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,mBAAmB;AACrB;;AAEA;;EAEE,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,yBAAyB;EACzB,qBAAqB;EACrB,gCAAgC;AAClC;;AAEA,YAAU,WAAW,EAAE,kBAAkB,EAAE;AAC3C,YAAU;AACV,YAAW,WAAW,EAAE,kBAAkB,EAAE;AAC5C,YAAQ,WAAW,EAAE,iBAAiB,EAAE;AACxC,YAAa,WAAW,EAAE,kBAAkB,EAAE;AAC9C,YAAkB,YAAY,EAAE,kBAAkB,EAAE;;AAEpD;EACE,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,gCAAgC;EAChC,mCAAmC;AACrC;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;AACb;;AAEA;;;EAGE,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,kCAAkC;AACpC;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,mCAAmC;EACnC,yCAAyC;EACzC,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE;;;IAGE,iBAAiB;IACjB,eAAe;EACjB;;EAEA;;IAEE,aAAa;EACf;;EAEA;;IAEE,WAAW;EACb;AACF;;AAEA,uCAAuC;AACvC;EACE;IACE,eAAe;EACjB;;EAEA;;;IAGE,gBAAgB;IAChB,eAAe;EACjB;;EAEA;;IAEE,aAAa;EACf;;EAEA;;IAEE,WAAW;EACb;;EAEA;;IAEE,WAAW;EACb;AACF","sourcesContent":[".container {\n  max-width: 800px;\n  margin: 0 auto;\n}\n\n.title {\n  font-size: 28px;\n  font-weight: 700;\n  color: #e0e0e0;\n  margin-bottom: 4px;\n}\n\n.stats {\n  font-size: 14px;\n  color: #888;\n  margin-bottom: 20px;\n}\n\n.loading,\n.empty {\n  text-align: center;\n  color: #888;\n  padding: 40px 0;\n  font-size: 16px;\n}\n\n.table {\n  width: 100%;\n  border-collapse: collapse;\n  background: #16213e;\n  border-radius: 8px;\n  overflow: hidden;\n}\n\n.table thead {\n  background: #1a1a2e;\n}\n\n.table th {\n  padding: 12px 16px;\n  text-align: left;\n  font-size: 12px;\n  font-weight: 600;\n  color: #888;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  border-bottom: 1px solid #2a2a4a;\n}\n\n.thRank { width: 50px; text-align: center; }\n.thName { }\n.thLevel { width: 80px; text-align: center; }\n.thXp { width: 80px; text-align: right; }\n.thLessons { width: 80px; text-align: center; }\n.thAchievements { width: 100px; text-align: center; }\n\n.row td {\n  padding: 10px 16px;\n  font-size: 14px;\n  color: #e0e0e0;\n  border-bottom: 1px solid #2a2a4a;\n}\n\n.currentUser td {\n  padding: 10px 16px;\n  font-size: 14px;\n  color: #e0e0e0;\n  border-bottom: 1px solid #2a2a4a;\n  background: rgba(78, 204, 163, 0.1);\n}\n\n.rank {\n  text-align: center;\n  font-weight: 600;\n  color: #888;\n}\n\n.medal1,\n.medal2,\n.medal3 {\n  font-size: 18px;\n}\n\n.name {\n  font-weight: 500;\n}\n\n.level {\n  text-align: center;\n  color: #4ecca3;\n  font-weight: 600;\n}\n\n.xp {\n  text-align: right;\n  color: #b0b0b0;\n  font-variant-numeric: tabular-nums;\n}\n\n.lessons {\n  text-align: center;\n  color: #b0b0b0;\n}\n\n.achievements {\n  text-align: center;\n  color: #b0b0b0;\n}\n\n.pagination {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 16px;\n  margin-top: 16px;\n  padding: 12px 0;\n}\n\n.pageBtn {\n  background: rgba(78, 204, 163, 0.1);\n  border: 1px solid rgba(78, 204, 163, 0.3);\n  color: #4ecca3;\n  padding: 6px 14px;\n  border-radius: 6px;\n  cursor: pointer;\n  font-size: 13px;\n  transition: background 0.2s;\n}\n\n.pageBtn:hover:not(:disabled) {\n  background: rgba(78, 204, 163, 0.2);\n}\n\n.pageBtn:disabled {\n  opacity: 0.4;\n  cursor: not-allowed;\n}\n\n.pageInfo {\n  color: #888;\n  font-size: 13px;\n}\n\n@media (max-width: 800px) {\n  .table th,\n  .row td,\n  .currentUser td {\n    padding: 8px 10px;\n    font-size: 12px;\n  }\n\n  .thAchievements,\n  .achievements {\n    display: none;\n  }\n\n  .thXp,\n  .xp {\n    width: 60px;\n  }\n}\n\n/* Responsive: 480px phone breakpoint */\n@media (max-width: 480px) {\n  .title {\n    font-size: 20px;\n  }\n\n  .table th,\n  .row td,\n  .currentUser td {\n    padding: 6px 6px;\n    font-size: 11px;\n  }\n\n  .thLessons,\n  .lessons {\n    display: none;\n  }\n\n  .thLevel,\n  .level {\n    width: 50px;\n  }\n\n  .thXp,\n  .xp {\n    width: 50px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `NHWThMEJ`,
	"title": `QgMPWGl9`,
	"stats": `mWeTVp7r`,
	"loading": `dixhJvmk`,
	"empty": `OlDmAhrS`,
	"table": `yz8jWziG`,
	"thRank": `XCgHhlvQ`,
	"thName": `zIeTBFbV`,
	"thLevel": `sWM9jDIM`,
	"thXp": `TnhquffF`,
	"thLessons": `_ahCWWe0`,
	"thAchievements": `mXzJqIZT`,
	"row": `bHabcAeO`,
	"currentUser": `Gq54GtL3`,
	"rank": `vjsPrPOK`,
	"medal1": `oRJj4Kaa`,
	"medal2": `z7GdM1eH`,
	"medal3": `gB8fO3vS`,
	"name": `esPMC9S4`,
	"level": `EqkwBd4k`,
	"xp": `T7V_RsOo`,
	"lessons": `gi9WFb7h`,
	"achievements": `KTs0y2Ln`,
	"pagination": `yow1uwVD`,
	"pageBtn": `xYRZ4y71`,
	"pageInfo": `_5sFiApd`
};
export default ___CSS_LOADER_EXPORT___;
